var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { staticClass: "pega-break" }, [
    _c("div", { staticClass: "boss-scout-confirm-container" }, [
      _c(
        "div",
        {
          staticClass: "boss-scout-confirm-header",
          attrs: { "data-test": "label-subject" },
        },
        [_vm._v("件名：" + _vm._s(_vm.subject) + "\n    ")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "boss-scout-confirm-body pega-pre-wrap" }, [
        _c("div", { staticClass: "boss-scout-confirm-contents" }, [
          _c(
            "div",
            { staticClass: "boss-scout-confirm-contents-text clearfix" },
            [
              _c("div", {
                staticClass: "boss-scout-confirm-contents-sentence float-left",
                attrs: { "data-test": "text-body" },
                domProps: { innerHTML: _vm._s(_vm.$sanitize(_vm.renderBody)) },
              }),
            ]
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "boss-layout-block" }, [
      _c("div", { staticClass: "boss-table-wrap" }, [
        _c("div", { staticClass: "boss-table-2" }, [
          _c(
            "div",
            { staticClass: "boss-table-2-layout boss-table-2-layout-half" },
            [
              _c("div", { staticClass: "boss-table-2-layout" }, [
                _c(
                  "div",
                  { staticClass: "boss-table-2-item boss-table-2-item-head" },
                  [_vm._v("ステータス")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "boss-table-2-item boss-table-2-item-body" },
                  [
                    _c("label", { attrs: { "data-test": "label-status" } }, [
                      _vm._v(_vm._s(_vm.status)),
                    ]),
                  ]
                ),
              ]),
            ]
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "boss-button-container" }, [
      _c(
        "button",
        {
          staticClass: "boss-button boss-button-return",
          attrs: { type: "button", "data-test": "button-back" },
          on: {
            click: function ($event) {
              return _vm.$emit("back")
            },
          },
        },
        [
          _c("span", { staticClass: "boss-button-return-text" }, [
            _vm._v("戻る"),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "boss-button-center boss-button-confirm",
          attrs: { type: "button", "data-test": "button-submit" },
          on: { click: _vm.onSubmit },
        },
        [
          _c("span", { staticClass: "boss-button-confirm-text" }, [
            _vm._v("この内容で送信する"),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }